<div id="mainLHSDiv">
    <div class="unitToggler">
        <div class="unitTogglerContentCel">
            <span>&#8451;</span>
        </div>
        <div class="unitTogglerContent">
            <mat-slide-toggle color=primary [(ngModel)]="unitTypeFahrenheit" (change)="handleSwitchSelection()"></mat-slide-toggle>
        </div>
        <div class="unitTogglerContentFah">
            <span>&#8457;</span>
        </div>
    </div>
    <div class="tempCityInfo" *ngIf="OneCallLocationWeatherData">
        <div class="temp">
            <span class="tempValue">{{currentTemp | number: '1.0-0'}}</span>
            <span *ngIf="displayUnitType === 'celcius'">&#8451;</span>
            <span *ngIf="displayUnitType === 'fahrenheit'">&#8457;</span>
        </div>
        <div class="tempMinMax my-2">
            <div class="tempMin">
                <span class="tempMinValue">Min: {{todayMinTemp | number: '1.0-0'}}</span>
                <span *ngIf="displayUnitType === 'celcius'">&#8451;</span>
                <span *ngIf="displayUnitType === 'fahrenheit'">&#8457;</span>
            </div>
            <div class="tempMax">
                <span class="tempMaxValue">Max: {{todayMaxTemp | number: '1.0-0'}}</span>
                <span *ngIf="displayUnitType === 'celcius'">&#8451;</span>
                <span *ngIf="displayUnitType === 'fahrenheit'">&#8457;</span>
            </div>
        </div>
        <div class="sunRiseSunset my-2">
            <div class="sunRiseDiv"><i class="fa fa-sun-o" aria-hidden="true"></i> Sunrise: {{sunriseTime | date:'h:mm a'}}</div>
            <div class="sunSetDiv"><i class="fa fa-moon-o" aria-hidden="true"></i> Sunset: {{sunsetTime | date:'h:mm a'}}</div>
        </div>
        <div class="weatherIconDiv">
            <img [src]="iconurl" alt="Icon" class="weatherIcon">
            <span class="weatherDesc">{{weatherDescrption | titlecase}}</span>
        </div>
        <div class="cityInfo mx-1">
            <!-- <span><i class="fa fa-location-arrow" aria-hidden="true"></i>&nbsp;{{cityName}}, {{countryName}}</span> -->
            <!-- <div><img [src]="countryFlagUrl" alt="Country Flag"></div> -->
            <div class="countryFlagDiv"><img [src]="countryFlagUrl" alt="Country Flag" class="countryFlag"></div>
            <span><lord-icon
                src="https://cdn.lordicon.com/zzcjjxew.json"
                trigger="loop"
                colors="primary:#ffffff,secondary:#ffffff"
                style="width:50px;height:50px">
            </lord-icon>&nbsp;{{cityName}}, {{countryName}}</span>
        </div>
        <div class="timeInfo my-2 d-grid gap-2">
            <!-- <div class="timeInfoDate"><i class="fa fa-calendar" aria-hidden="true"></i>&nbsp;{{currentDatetime | date:'EEEE, MMM d, y'}}</div>
            <div class="timeInfoTime"><i class="fa fa-clock-o" aria-hidden="true"></i>&nbsp;{{currentDatetime | date:'h:mm a'}}</div> -->
            <div class="timeInfoDate">
                <lord-icon
                    src="https://cdn.lordicon.com/gmzxduhd.json"
                    trigger="loop"
                    colors="primary:#ffffff,secondary:#ffffff"
                    style="width:50px;height:50px">
                </lord-icon>&nbsp;{{currentDatetime | date:'EEEE, MMM d, y'}}
            </div>
            <div class="timeInfoTime">
                <lord-icon
                    src="https://cdn.lordicon.com/kbtmbyzy.json"
                    trigger="loop"
                    colors="primary:#ffffff,secondary:#ffffff"
                    style="width:50px;height:50px">
                </lord-icon>&nbsp;{{currentDatetime | date:'h:mm a'}}
            </div>
        </div>
    </div>
</div>
